import { render, staticRenderFns } from "./document-modal.vue?vue&type=template&id=f77bbc5c&"
import script from "./document-modal.vue?vue&type=script&lang=js&"
export * from "./document-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports